<template>

	<div class="company-tour">

		<TourSection v-for="sectionKey in ['WHO_WE_ARE', 'ACCESS_FOR_ALL', 'EXPAND_THE_POSSIBILITIES']" :key="sectionKey" v-bind="sections[sectionKey]" />

		<TourSection id="make-an-impact">
			<template slot-scope>
				<div class="impact__upper">
					<container>
						<h2>Make an Impact</h2>
						<p>We set the industry standard for bringing learning to life. We are dedicated to producing the highest quality content — from instruction, to imagery and motion graphics, to audio and video. And, we’ve built an entire production studio to create compelling educational content.</p>
					</container>
				</div>
				<div class="impact__showcase">
					<LibraryShowcase />
				</div>
				<div class="impact__lower">
					<container>
						<h4>Join more than 4,000,000 students & teachers on StudySync</h4>
						<btn><router-link :to="{name: 'freeTrial'}">Start Your Free Trial</router-link></btn>
					</container>
				</div>
			</template>
		</TourSection>

		<TourSection v-bind="sections.LIVE_TO_LEARN" />

		<TourSection v-for="sectionKey in ['ACCESS_FOR_ALL', 'LIVE_TO_LEARN']" :key="`quote-${sectionKey}`" v-bind="sections[sectionKey]" :quoteOnly="true" />

	</div>


</template>

<script>

	import requireDir from 'webpack-requiredir'
	const components = requireDir(require.context('./components'))

	export default {
		name: 'companyTour',
		components,
		data () {
			return {
				sections: {
					WHO_WE_ARE: {
						primary: {
							background: {
								inline: require('./img/primary/who-we-are__large.jpg'),
								stacked: require('./img/primary/who-we-are__small.jpg')
							},
							gravity: 'top left',
							headline: `Who We Are`,
							html: `
								<p>StudySync creates and publishes award-winning educational curriculum for schools in English language arts, ELL, social studies and science.<br><br>While leveraging technology and media to engage and inspire students in their academic pursuits, StudySync provides educators with an easy-to-use platform to deliver adaptable and interactive learning solutions.</p>
							`
						}
					},
					ACCESS_FOR_ALL: {
						primary: {
							background: {
								inline: require('./img/primary/access-for-all__large.jpg'),
								stacked: require('./img/primary/access-for-all__small.jpg')
							},
							gravity: 'top left',
							headline: `Access For All`,
							html: `
								<p>Our products are built for all learners, because every student deserves the same opportunity and access in the classroom, regardless of learning level, native language, or social, physical, or emotional ability.</p>
							`
						},
						aside: {
							background: {
								inline: require('./img/aside/access-for-all__large.jpg'),
								stacked: require('./img/aside/access-for-all__small.jpg')
							},
							quote: {
								author: {
									headshot: require('@/assets/img/jodee-boehm.png'),
									title: 'Jodee Boehm, Providence High School',
								},
								quote: `I’m hooked and can’t ever imagine teaching without StudySync.`
							}
						}
					},
					EXPAND_THE_POSSIBILITIES: {
						primary: {
							background: {
								inline: require('./img/primary/expand-the-possibilities__large.jpg'),
								stacked: require('./img/primary/expand-the-possibilities__small.jpg')
							},
							gravity: 'bottom left',
							headline: `Expand the Possibilities`,
							html: `
								<p>We believe teachers deserve flexibility and choice.  From high tech to low tech classrooms, StudySync creates tools in the format that's right for you – print or digital, mobile or desktop.</p>
							`
						}
					},
					LIVE_TO_LEARN: {
						primary: {
							background: {
								inline: require('./img/primary/live-to-learn__large.jpg'),
								stacked: require('./img/primary/live-to-learn__small.jpg')
							},
							gravity: 'top left',
							headline: `Live to Learn`,
							html: `
								<p>We believe that learning is a life-long pursuit. When provided inspired content, students realize that learning is living. We use every opportunity to make learning rigorous, engaging and meaningful.</p>
							`
						},
						aside: {
							background: {
								inline: require('./img/aside/live-to-learn__large.jpg'),
								stacked: require('./img/aside/live-to-learn__small.jpg')
							},
							quote: {
								author: {
									headshot: require('@/assets/img/catlin-tucker.png'),
									title: 'Catlin Tucker, Windsor High School',
								},
								quote: `My students enjoy that StudySync is helping English Class to Evolve with the Times.`
							}
						}
					}
				}
			}
		}
	}

</script>

<style lang="scss" scoped>

	@import "list-style-reset";
	@import "media";
	@import "responsive-font";

	.company-tour {
		width:100%;
	}

	#make-an-impact {
		display:block; min-height:0; overflow:hidden;
		.impact {
			&__lower {
				text-align:center;
				h4 {
					text-transform:uppercase; font-weight:400; line-height:1.25;
				}
				.btn {
					display:inline-block; margin-top:2.5rem;
				}
			}
		}
		&.inline {
			.impact {
				&__upper, &__lower {
					margin:6vw 0;
				}
				&__upper {
					text-align:center;
				}
				&__lower {
					h4 {
						@include responsive-font(30);
					}
				}
			}
			.container {
				max-width:80%;
			}
		}
		&.stacked {
			background:#F6F8F9; margin-bottom:-10vw;
			.impact {
				&__lower {
					h4 {
						font-size:4rem;
					}
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/CompanyTour/index.vue